module.exports = __webpack_public_path__ + "img/ys-6.32e13358.png";